Router = App.loadClass 'core::Router'

try
    PlacementHandler = App.loadClass('grower::handlers/placement/PlacementHandler')
catch e
    # prevents errors where PlacementHandler isn't loaded (e.g. on touchpoint)
    PlacementHandler = () => null


Contacts_Handler = App.loadClass('grower::handlers/contacts/Contacts_Handler')


class exports.NavigationRouter extends Router
    module_name: 'NavigationRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router']

        @module.controller 'NavigationController', [
            '$scope'
            '$state'
            '$transitions'
            '$rootScope'
            '$http'
            ($scope, $state, $transitions, $rootScope, $http) ->
                $scope.$state = $state

                # Initialize confirmation notification data
                $scope.confirm =
                    showAlert: false
                    tab: null

                # Query the backend for persistent notifications
                $http.get 'backend/grower/notification/notifications'
                    .then (response) =>
                        # confirmation notification
                        if response.data.includes 'map_confirmation'
                            $scope.confirm.showAlert = true

                $scope.isOnData = ->
                    return $state.includes('grower.data') or
                        $state.includes('grower.zone') or
                        ($state.includes('grower.planting-rx') and
                            App.current_page not instanceof PlacementHandler)

                $scope.isOnFields = ->
                    return $state.includes('grower.fields-define') or
                        (
                            App.current_page instanceof Fields_Handler and
                            not $state.includes('grower.data') and
                            not $state.includes('grower.operation') and
                            App.current_page not instanceof PlacementHandler
                        )

                $scope.isOnOperation = ->
                    $state.includes('grower.operation')

                # This allows us to delay updating the nav bar until we're sure the
                # state transition succeeded. (If it failed or was cancelled, we
                # don't want to update the nav bar.)
                # $transitions.onSuccess {}, ($transition) =>
                    # hax to make drawing tools highlighting work properly
                    # if $transition.to().name.indexOf('grower.data') > -1 and App.current_page instanceof Fields_Handler
                    #     return

                    # If going from/to a Handler page, App needs to update the nav.
                    #if ($transition.from()?.name in [null, 'grower'] or $transition.to()?.name in [null, 'grower'])
                    #    App.doNavChange()

                $scope.fieldprint =
                    showAlert: false
                    id: null

                unregisterFieldprintCompleteHandler = Socket.register 'fieldprintChanged', (data) ->
                    if data.newScores and data.fpcResult.dryland_status is 'success' and data.fpcResult.irrigated_status is 'success'
                        $scope.$apply () ->
                            $scope.fieldprint.showAlert = true
                            $scope.fieldprint.id = data.fpcResult.id

                    $rootScope.$broadcast 'fieldprintChanged', data.fpcResult

                $scope.$on '$destroy', =>
                    unregisterFieldprintCompleteHandler()

                $scope.fieldprintButtonClicked = () =>
                    $scope.fieldprint.showAlert = false

                # Maps Confirmation Notification
                unregisterConfirmMapsHandler = Socket.register 'mapDataStatusUpdated', (data) ->
                    if data.status is 'Success'
                        $scope.$apply () ->
                            $scope.confirm.showAlert = true
                            $scope.confirm.tab = data.type

                $scope.$on '$destroy', =>
                    unregisterConfirmMapsHandler()

                $scope.confirmMapsButtonClicked = () =>
                    $http.post 'backend/grower/notification/delete',
                        notification_name: ['map_confirmation']
                    $scope.confirm.showAlert = false

                $scope.finishImportingFieldView = () ->
                    $('#fieldview-pending').toggle('slide')
                    return
                $scope.finishImportingFieldViewYield = () ->
                    $('#fieldview-pending-yield').toggle('slide')
                    return
                $scope.finishImportingFieldViewApplication = () ->
                    $('#fieldview-pending-application').toggle('slide')
                    return
                $scope.finishImportingFieldViewPlanting = () ->
                    $('#fieldview-pending-planting').toggle('slide')
                    return
                $scope.finishImportingJohnDeere = () ->
                    $('#johndeere-pending').toggle('slide')
                    return
                $scope.finishImportingJohnDeereYield = () ->
                    $('#johndeere-pending-yield').toggle('slide')
                    return
                $scope.finishImportingJohnDeereApplication = () ->
                    $('#johndeere-pending-application').toggle('slide')
                    return
                $scope.finishImportingJohnDeerePlanting = () ->
                    $('#johndeere-pending-planting').toggle('slide')
                    return
        ]
